import React from 'react';

import { Text } from 'components/v2/Typography/Text';

import { CancellationPolicyProps } from './CancellationPolicy.types';
import { NavigatorEmail } from './NavigatorEmail';
import { NavigatorNumber } from './NavigatorNumber';

const getNoCancelNorRescheduleVariant = (emailBody: string) => {
  return (
    <p>
      <Text>
        This appointment cannot be canceled nor rescheduled in the Patient Portal. Please call us at{' '}
      </Text>
      <NavigatorNumber />
      <Text> or email us at </Text>
      <NavigatorEmail emailBody={emailBody} />
      <Text> to cancel or reschedule your appointment.</Text>
    </p>
  );
};

const getMoreThan24HoursVariant = (emailBody: string) => {
  return (
    <p>
      <Text>
        To reschedule or cancel with less than 24 hours notice, or if you have any questions, email
        us at{' '}
      </Text>
      <NavigatorEmail emailBody={emailBody} />
      <Text> or call us at </Text>
      <NavigatorNumber />
      <Text>.</Text>
    </p>
  );
};

export const CancellationPolicy = ({
  emailBody,
  noCancelNorRescheduleVariant
}: CancellationPolicyProps): JSX.Element => {
  if (noCancelNorRescheduleVariant) return getNoCancelNorRescheduleVariant(emailBody);

  return getMoreThan24HoursVariant(emailBody);
};
